'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AlignmentEnum = exports.AlignmentEnum = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/Enums.js
// module id = 64
// module chunks = 10